import classNames from 'classnames'
import BaseTooltip from 'components/BaseTooltip'
import React, { useMemo } from 'react'
import OrganizationLogo from 'scenes/Dashboard/components/OrganizationLogo'
import { Organization } from 'scenes/Dashboard/data/organizations/types'
import { makeStyles } from 'tss-react/mui'

import { Theme, useTheme } from '@mui/material'

export type DealCardCompanyLogoProps = {
  className?: string
  style?: React.CSSProperties
  organization: Organization
  onClick?: () => void
}

export const DealCardCompanyLogo = React.memo(
  ({ className, style, organization, onClick }: DealCardCompanyLogoProps) => {
    const theme: Theme = useTheme()
    const { classes } = useStyles()
    const logoSize = useMemo(() => theme.spacing(6), [theme])
    return (
      <BaseTooltip title="Click to open scorecard" bottom>
        <div className={classNames(className, classes.organizationLogo)} style={style} onClick={onClick}>
          <OrganizationLogo organization={organization} size={logoSize} />
        </div>
      </BaseTooltip>
    )
  }
)

DealCardCompanyLogo.displayName = 'DealCardCompanyLogo'

const useStyles = makeStyles()({
  organizationLogo: {
    display: 'flex',
    cursor: 'pointer',
  },
})
